import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="flag-1, priority" maskId="round-filled-radius-1-stroke-1.5-IconFlag1"><path d="M5.75 2C4.7835 2 4 2.7835 4 3.75V21.25C4 21.6642 4.33579 22 4.75 22C5.16421 22 5.5 21.6642 5.5 21.25V15.5H19.3815C20.7792 15.5 21.6129 13.9422 20.8376 12.7793L18.2438 8.88868C18.1879 8.8047 18.1879 8.6953 18.2438 8.61133L20.8376 4.72073C21.6129 3.55775 20.7792 2 19.3815 2H5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag1;
